import React, { useEffect, useState } from "react";
import { ICON_COLORS } from "@/components/common/AssetIcon";

// The terminal "dots" spinner, ⠋⠙⠹⠸⠼⠴⠦⠧⠇⠏: bit i lights braille dot i + 1.
const FRAMES = [0x0b, 0x19, 0x39, 0x38, 0x3c, 0x34, 0x26, 0x27, 0x07, 0x0f];
// Dots 1-3 down the left column, 4-6 down the right, in the 16-unit icon box.
const DOTS = [0, 1, 2, 3, 4, 5].map((i) => [
  i < 3 ? 5.5 : 10.5,
  3 + 5 * (i % 3),
]);
const DOT = 2.6;
const FRAME_MS = 80;

/** Drawn rather than typed: Geist Mono has no braille glyphs. */
export const OpeningSpinner: React.FC<{
  color?: string;
  ariaLabel?: string;
}> = ({ color, ariaLabel = "Opening" }) => {
  const [frame, setFrame] = useState(0);
  useEffect(() => {
    const id = setInterval(
      () => setFrame((f) => (f + 1) % FRAMES.length),
      FRAME_MS,
    );
    return () => clearInterval(id);
  }, []);

  return (
    <svg
      viewBox="0 0 16 16"
      className="w-4 h-4 shrink-0"
      style={{ fill: color || ICON_COLORS[0] }}
      role="img"
      aria-label={ariaLabel}
    >
      {DOTS.map(([x, y], i) =>
        FRAMES[frame] & (1 << i) ? (
          <rect
            key={i}
            x={x - DOT / 2}
            y={y - DOT / 2}
            width={DOT}
            height={DOT}
            rx={0.3}
          />
        ) : null,
      )}
    </svg>
  );
};
